var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportTickets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.645,
    height: 16.645,
    viewBox: "0 0 16.645 16.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.153,4.545A2.158,2.158,0,0,1,12.1,1.493L10.608,0,0,10.608,1.493,12.1a2.158,2.158,0,0,1,3.053,3.053l1.493,1.493L16.645,6.038Zm-6.846,1.4-.692-.692.69-.69L9,5.258ZM9.692,7.332,9,6.64l.69-.69.692.692Zm1.385,1.385-.692-.692.69-.69.692.692Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTickets);
export default __webpack_public_path__ + "static/media/supportTickets.6d61826fbdb511f6abe744daf69f6fce.svg";
export { ForwardRef as ReactComponent };